import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
const borderColor = '#90e5fc';
const tableBorderColor = '#000000';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: "#bff0fd",
        borderBottomWidth: 1,
        alignItems: "center",
        height: 24,
        backgroundColor: '#F1F1F1',

    },
    headerContainer: {
        flexDirection: 'row',
        borderBottomColor: "#bff0fd",
        borderBottomWidth: 1,
        alignItems: "center",
        height: 24,
        backgroundColor: '#bff0fd',
    },
    column1: {
        width: '20%',
        justifyContent: 'center',
        alignItems: 'center',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    column2: {
        width: '20%',
        justifyContent: 'center',
        alignItems: 'center',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    column3: {
        width: '60%',
        justifyContent: 'center',
        alignItems: 'center',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    header1: {
        width: '20%',
        borderStyle:"solid",
        borderColor:'gray',
        borderWidth:0.1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#bff0fd',
    },
    header2: {
        width: '20%',
        borderStyle:"solid",
        borderColor:'gray',
        borderWidth:0.1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#bff0fd',
    },
    header3: {
        width: '60%',
        borderStyle:"solid",
        borderColor:'gray',
        borderWidth:0.1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#bff0fd',
    },
    headerText: {
        fontFamily: 'NotoNastaliqUrdu',
    },
    headerText1: {
        fontFamily: 'NotoNastaliqUrdu',
        fontWeight:'bold',
        fontSize: 14,
    },
    cellText: {
        fontFamily: 'NotoNastaliqUrdu',
        fontSize: 13,
        fontWeight:'bold',
        
    },
});

const InvoiceTray   = ({ items, invoice }) => {

  return (
    <>
{invoice.payment > 0 && (
    <View>
        <View style={styles.headerContainer}>
            <View style={styles.header1}>
                <Text style={styles.headerText1}>بسکٹ ٹرے</Text>
            </View>
            <View style={styles.header2}>
                <Text style={styles.headerText1}>میٹھائی ٹرے</Text>
            </View>
            <View style={styles.header3}>
                <Text style={styles.headerText1}>ٹرے ڈیٹیل</Text>
            </View>
        </View>
        <View style={styles.container}>
            <View style={styles.column1}>
                <Text style={styles.cellText}>{invoice.trayBDispatch}</Text>
            </View>
            <View style={styles.column2}>
                <Text style={styles.cellText}>{invoice.trayADispatch}</Text>
            </View>
            <View style={styles.column3}>
                <Text style={styles.cellText}>آج کا ٹرے</Text>
            </View>
        </View>
        <View style={styles.container}>
            <View style={styles.column1}>
                <Text style={styles.cellText}>{invoice.trayBReturn}</Text>
            </View>
            <View style={styles.column2}>
                <Text style={styles.cellText}>{invoice.trayAReturn}</Text>
            </View>
            <View style={styles.column3}>
                <Text style={styles.cellText}>واپسی</Text>
            </View>
        </View>
        <View style={styles.container}>
            <View style={styles.column1}>
                <Text style={styles.cellText}>{invoice.trayBPending}</Text>
            </View>
            <View style={styles.column2}>
                <Text style={styles.cellText}>{invoice.trayAPending}</Text>
            </View>
            <View style={styles.column3}>
                <Text style={styles.cellText}>ٹرے پینڈنگ</Text>
            </View>
        </View>
    </View>
)}


    </>
  );
};

export default InvoiceTray  ;
